import type React from 'react';

/** @deprecated Use icons from icons-v2-generated instead. */
export const AutomateEverythingIcon = ({
  className,
  ...props
}: { className?: string } & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.37549 7.00049V5.64111C5.53284 7.41731 4.1252 9.05535 4.125 12.0015C4.125 15.3215 6.18011 18.1651 9.09082 19.3228L9.375 19.4297L9.48193 19.4736C9.99718 19.7172 10.2546 20.3163 10.0605 20.8652C9.86623 21.4144 9.28902 21.7181 8.73486 21.583L8.625 21.5508L8.26025 21.4131C4.52094 19.9259 1.875 16.274 1.875 12.0015C1.87522 8.27133 3.76724 5.9895 5.68799 4.125H4.5C3.87868 4.125 3.375 3.62132 3.375 3C3.375 2.37868 3.87868 1.875 4.5 1.875H8.50049C8.74031 1.8751 8.96984 1.95502 9.16113 2.09473C9.19916 2.1225 9.23593 2.1524 9.271 2.18555C9.27845 2.1926 9.28862 2.19731 9.2959 2.20459C9.30227 2.21097 9.30581 2.22005 9.31201 2.22656C9.34808 2.26429 9.38035 2.30403 9.41016 2.34521C9.50496 2.47699 9.57247 2.6256 9.60352 2.78467C9.61745 2.85574 9.62535 2.92783 9.62549 3V7.00049C9.62522 7.62142 9.12142 8.12523 8.50049 8.12549C7.87933 8.12549 7.37575 7.62158 7.37549 7.00049Z"
        fill="#FFC008"
      />
      <path
        d="M19.875 11.9994C19.8748 8.67963 17.8197 5.83725 14.9092 4.6796L14.625 4.57266L14.5181 4.52872C14.0028 4.28519 13.7454 3.68612 13.9395 3.13712C14.1337 2.58787 14.711 2.2829 15.2651 2.41788L15.375 2.45157L15.7397 2.58926C19.4788 4.07642 22.1248 7.72721 22.125 11.9994C22.125 15.7281 20.2348 18.0103 18.3149 19.8744H19.5L19.6157 19.8803C20.1825 19.9382 20.6247 20.4174 20.625 20.9994C20.625 21.5816 20.1826 22.0606 19.6157 22.1186L19.5 22.1244H15.4995C14.8784 22.1242 14.3745 21.6206 14.3745 20.9994V17.0004C14.3745 16.3792 14.8784 15.8757 15.4995 15.8754C16.1208 15.8754 16.6245 16.3791 16.6245 17.0004V18.3598C18.467 16.5837 19.875 14.9456 19.875 11.9994Z"
        fill="#FFC008"
      />
    </svg>
  );
};
